var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { SellingPointsTags, } from "../../../services/savvy/types";
function SellingPointTag(_a) {
    var tag = _a.tag;
    if (tag === SellingPointsTags.amex) {
        return React.createElement("span", { className: "mr-1 text-xs font-bold text-[#016FD0]" }, "AMEX");
    }
    return null;
}
function SellingPoints(_a) {
    var tag = _a.tag, title = _a.title, sellingPoints = _a.sellingPoints;
    return (React.createElement("div", { className: "text-xs" },
        React.createElement("div", { className: "mb-1 flex items-center" },
            tag ? React.createElement(SellingPointTag, { tag: tag }) : null,
            React.createElement("span", { className: "text-gray-100" }, title)),
        sellingPoints ? (React.createElement("ul", { className: "list-disc pl-4 text-black" }, sellingPoints === null || sellingPoints === void 0 ? void 0 : sellingPoints.map(function (sellingPoint) { return (React.createElement("li", { key: sellingPoint.text, className: "mb-1 last:mb-0" }, sellingPoint.text)); }))) : null));
}
export function SellingPointGroups(_a) {
    var groups = _a.groups;
    if (!groups || groups.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null, groups === null || groups === void 0 ? void 0 : groups.map(function (sellingPoint, index) { return (React.createElement(SellingPoints, __assign({}, sellingPoint, { key: sellingPoint.title + index }))); })));
}
